var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16666 15.919L0.5 21.882V1.91667C0.5 1.12343 1.12551 0.5 1.875 0.5H13.125C13.8745 0.5 14.5 1.12343 14.5 1.91667V21.882L7.83334 15.919L7.5 15.6208L7.16666 15.919Z",
    fill: "white",
    fillOpacity: 0.3,
    stroke: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrap);
export default __webpack_public_path__ + "static/media/scrap.4ab7b3e5ffa1faff0094475083a75a3c.svg";
export { ForwardRef as ReactComponent };